import { Component, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { AbstractComponent } from '../../abstract.component';
import { DialogService, DialogServiceState } from '../../../services/dialog.service';
import { TimerTools } from '../../../tools/timer-tools';
import { SolDialogsState, DialogContainerVisibility } from './sol-dialogs.state';
import { SolDialogContainerComponent } from '../sol-dialog-container/sol-dialog-container.component';

@Component({
  selector: 'sol-dialogs',
  imports: [CdkTrapFocus, SolDialogContainerComponent],
  templateUrl: './sol-dialogs.component.html',
})
export class SolDialogsComponent extends AbstractComponent<SolDialogsState> {
  // Dependencies
  private readonly dialogService = inject(DialogService);

  // Computed
  protected entries$ = this.compute(state => state.entries);
  protected visibility$ = this.compute(state => state.visibility);
  protected visible$ = this.compute(state => state.visible);

  // Cache
  private opacityTimer?: Subscription;

  constructor() {
    super(SolDialogsState.of());

    this.dialogService.watch(dss => this.onServiceStateUpdate(dss));
    this.watchComputed(
      state => SolDialogsState.shouldFade(state),
      shouldFade => this.handleFade(shouldFade),
    );
  }

  private onServiceStateUpdate(dss: DialogServiceState): void {
    this.update(state => state.withEntries(dss.entries));
  }

  private handleFade(shouldFade: boolean): void {
    if (!shouldFade) {
      return;
    }

    this.updateVisibility();
    this.opacityTimer?.unsubscribe();
    this.opacityTimer = TimerTools.timer$(150, this.destroyRef).subscribe(() => this.updateVisibility());
  }

  private updateVisibility(): void {
    const visibility: DialogContainerVisibility = SolDialogsState.calculateVisibility(this.state);
    this.update(state => state.withVisibility(visibility));
  }
}
